import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { FormBuilder, FormArray, Validators } from "@angular/forms";
import { SelectionList } from "../selection-list";
import { BaseFieldEditorComponent } from "../../base-field-editor.component";
import { RxwebValidators } from "@rxweb/reactive-form-validators";

@Component({
    selector: "single-selection-dropdown-editor",
    templateUrl: "./single-selection-dropdown-editor.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleSelectionDropdownEditorComponent extends BaseFieldEditorComponent implements OnInit, OnDestroy {
    constructor(_changeDetector: ChangeDetectorRef, private _formBuilder: FormBuilder) {
        super(_changeDetector);
    }

    ngOnInit(): void {
        this.form = this._formBuilder.group({
            placeholder: [this.selectionList.placeholder],
            options: new FormArray(
                this.selectionList.options.map((o) =>
                    this._formBuilder.group({
                        value: [o.value, [Validators.required]],
                        text: [o.text, [Validators.required, RxwebValidators.unique()]],
                    })
                )
            ),
        });
        super.onInit();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    get selectionList() {
        return this.field as SelectionList;
    }

    get options() {
        return this.form.get("options") as FormArray;
    }

    addOption() {
        const option = this.selectionList.createOption();
        this.options.push(
            this._formBuilder.group({
                value: [option.value, [Validators.required]],
                text: [option.text, [Validators.required, RxwebValidators.unique()]],
            })
        );
    }

    deleteOption(index: number) {
        this.options.removeAt(index);
        this._changeDetector.detectChanges();
    }
}
